import React, { useState } from 'react';
import { Coffee, UtensilsCrossed, Flag, ClipboardCheck, MessageCircle } from 'lucide-react';
interface ProgramItem {
  id: string;
  time: string;
  endTime: string;
  title: string;
  speaker?: string;
  role?: string;
  image?: string;
  isBreak?: boolean;
}
const SPEAKERS = {
  peterHawkins: {
    name: 'Peter Hawkins',
    role: 'Professor of Leadership, Henley Business School',
    image: 'https://cdn.magicpatterns.com/uploads/ayxuyEqd7o6PGA79aXmM36/Screenshot_2026-03-09_alle_11.46.10.png'
  },
  alessandraGalloni: {
    name: 'Alessandra Galloni',
    role: 'Editor-in-Chief, Reuters',
    image: 'https://cdn.magicpatterns.com/uploads/7f7mEHgBp9MZgsCiKHWfLG/Screenshot_2026-03-09_alle_11.45.45.png'
  },
  simonaFontana: {
    name: 'Simona Fontana',
    role: 'Director General, Conai',
    image: 'https://cdn.magicpatterns.com/uploads/n6YJMpbDema4og4a2kUWqH/Screenshot_2026-03-09_alle_11.45.34.png'
  },
  deliaCiccarelli: {
    name: 'Delia Ciccarelli',
    role: "Impact Director Italy, McDonald's",
    image: 'https://cdn.magicpatterns.com/uploads/6xCzmVBTpgNAYyCSvhhhZG/Screenshot_2026-03-09_alle_11.45.23.png'
  },
  marceloCabrol: {
    name: 'Marcelo Cabrol',
    role: 'Chief of Strategy, Knowledge and Impact, IDB Lab',
    image: 'https://cdn.magicpatterns.com/uploads/pBqU2EDZetkagEQzGwG96L/Screenshot_2026-03-09_alle_11.44.06.png'
  }
};
const DAY1_PROGRAM: ProgramItem[] = [{
  id: 'd1-1',
  time: '09:00',
  endTime: '09:30',
  title: 'Registrazione e Welcome Coffee',
  isBreak: true
}, {
  id: 'd1-2',
  time: '09:30',
  endTime: '10:15',
  title: 'Leadership sistemica per un futuro sostenibile',
  speaker: SPEAKERS.peterHawkins.name,
  role: SPEAKERS.peterHawkins.role,
  image: SPEAKERS.peterHawkins.image
}, {
  id: 'd1-3',
  time: '10:15',
  endTime: '11:00',
  title: 'Il ruolo dei media nella transizione ecologica',
  speaker: SPEAKERS.alessandraGalloni.name,
  role: SPEAKERS.alessandraGalloni.role,
  image: SPEAKERS.alessandraGalloni.image
}, {
  id: 'd1-4',
  time: '11:00',
  endTime: '11:30',
  title: 'Coffee Break',
  isBreak: true
}, {
  id: 'd1-5',
  time: '11:30',
  endTime: '12:15',
  title: 'Economia circolare: dal packaging al sistema',
  speaker: SPEAKERS.simonaFontana.name,
  role: SPEAKERS.simonaFontana.role,
  image: SPEAKERS.simonaFontana.image
}, {
  id: 'd1-6',
  time: '12:15',
  endTime: '13:00',
  title: "Misurare l'impatto: metriche che contano",
  speaker: 'Panel Discussion'
}, {
  id: 'd1-7',
  time: '13:00',
  endTime: '14:30',
  title: 'Networking Lunch',
  isBreak: true
}, {
  id: 'd1-8',
  time: '14:30',
  endTime: '15:15',
  title: "Corporate impact: il caso McDonald's Italia",
  speaker: SPEAKERS.deliaCiccarelli.name,
  role: SPEAKERS.deliaCiccarelli.role,
  image: SPEAKERS.deliaCiccarelli.image
}, {
  id: 'd1-9',
  time: '15:15',
  endTime: '16:00',
  title: 'Innovazione sociale in America Latina',
  speaker: SPEAKERS.marceloCabrol.name,
  role: SPEAKERS.marceloCabrol.role,
  image: SPEAKERS.marceloCabrol.image
}, {
  id: 'd1-10',
  time: '16:00',
  endTime: '16:30',
  title: 'Coffee Break',
  isBreak: true
}, {
  id: 'd1-11',
  time: '16:30',
  endTime: '17:30',
  title: "Il futuro dell'impatto in Europa",
  speaker: 'Tavola rotonda'
}, {
  id: 'd1-12',
  time: '17:30',
  endTime: '18:00',
  title: 'Closing remarks Giorno 1',
  isBreak: true
}];
const DAY2_PROGRAM: ProgramItem[] = [{
  id: 'd2-1',
  time: '09:00',
  endTime: '09:30',
  title: 'Welcome Coffee',
  isBreak: true
}, {
  id: 'd2-2',
  time: '09:30',
  endTime: '10:15',
  title: 'Finanza per lo sviluppo: nuovi modelli',
  speaker: SPEAKERS.marceloCabrol.name,
  role: SPEAKERS.marceloCabrol.role,
  image: SPEAKERS.marceloCabrol.image
}, {
  id: 'd2-3',
  time: '10:15',
  endTime: '11:00',
  title: 'Coaching trasformativo nelle organizzazioni',
  speaker: SPEAKERS.peterHawkins.name,
  role: SPEAKERS.peterHawkins.role,
  image: SPEAKERS.peterHawkins.image
}, {
  id: 'd2-4',
  time: '11:00',
  endTime: '11:30',
  title: 'Coffee Break',
  isBreak: true
}, {
  id: 'd2-5',
  time: '11:30',
  endTime: '12:15',
  title: "Giornalismo d'impatto e responsabilità sociale",
  speaker: SPEAKERS.alessandraGalloni.name,
  role: SPEAKERS.alessandraGalloni.role,
  image: SPEAKERS.alessandraGalloni.image
}, {
  id: 'd2-6',
  time: '12:15',
  endTime: '13:00',
  title: 'Supply chain sostenibile: sfide e opportunità',
  speaker: SPEAKERS.deliaCiccarelli.name,
  role: SPEAKERS.deliaCiccarelli.role,
  image: SPEAKERS.deliaCiccarelli.image
}, {
  id: 'd2-7',
  time: '13:00',
  endTime: '14:30',
  title: 'Networking Lunch',
  isBreak: true
}, {
  id: 'd2-8',
  time: '14:30',
  endTime: '15:15',
  title: "Policy europee per l'economia circolare",
  speaker: SPEAKERS.simonaFontana.name,
  role: SPEAKERS.simonaFontana.role,
  image: SPEAKERS.simonaFontana.image
}, {
  id: 'd2-9',
  time: '15:15',
  endTime: '16:00',
  title: 'Startup e impatto: scalare il cambiamento',
  speaker: 'Panel'
}, {
  id: 'd2-10',
  time: '16:00',
  endTime: '17:00',
  title: 'Design your impact strategy',
  speaker: 'Workshop interattivo'
}, {
  id: 'd2-11',
  time: '17:00',
  endTime: '17:30',
  title: 'Closing Ceremony',
  isBreak: true
}];
// Simulate current time at 14:45 on Day 1
const CURRENT_TALK_ID = 'd1-8'; // Delia Ciccarelli
const NEXT_TALK_ID = 'd1-9'; // Marcelo Cabrol
export function SummitHome() {
  const [selectedDay, setSelectedDay] = useState<1 | 2>(1);
  const program = selectedDay === 1 ? DAY1_PROGRAM : DAY2_PROGRAM;
  const currentTalk = DAY1_PROGRAM.find(item => item.id === CURRENT_TALK_ID);
  const nextTalk = DAY1_PROGRAM.find(item => item.id === NEXT_TALK_ID);
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden" data-id="element-549">
      {/* Fixed Header */}
      <div className="bg-[#0D0D0D] border-b border-[#2A2A2A]/50 px-6 pt-10 pb-4 flex-shrink-0" data-id="element-550">
        <h1 className="font-medium text-white text-[17px] tracking-tight" data-id="element-551">
          Programma
        </h1>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto min-h-0" data-id="element-552">
        <div className="px-6 py-4" data-id="element-553">
          {/* Day Selector */}
          <div className="flex gap-2 mb-6" data-id="element-554">
            <button onClick={() => setSelectedDay(1)} className={`px-4 py-2 rounded-full text-[13px] font-medium transition-all duration-200 ${selectedDay === 1 ? 'bg-[#C5D82D] text-[#0D0D0D]' : 'bg-[#141414] text-white border border-[#2A2A2A]'}`} data-id="element-555">
              Giorno 1
            </button>
            <button onClick={() => setSelectedDay(2)} className={`px-4 py-2 rounded-full text-[13px] font-medium transition-all duration-200 ${selectedDay === 2 ? 'bg-[#C5D82D] text-[#0D0D0D]' : 'bg-[#141414] text-white border border-[#2A2A2A]'}`} data-id="element-556">
              Giorno 2
            </button>
          </div>

          {/* NOW Section - Only show on Day 1 */}
          {selectedDay === 1 && currentTalk && <div className="mb-6" data-id="element-557">
              <div className="bg-[#141414] rounded-xl border border-[#2A2A2A] p-4 relative" data-id="element-558">
                {/* Live badge top-right */}
                <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-500/10" data-id="element-559">
                  <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-560" />
                  <span className="text-[10px] font-medium text-red-400 uppercase tracking-wider" data-id="element-561">
                    Live
                  </span>
                </div>
                <div className="flex gap-4" data-id="element-562">
                  {currentTalk.image && <img src={currentTalk.image} alt={currentTalk.speaker} className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-563" />}
                  <div className="flex-1 min-w-0" data-id="element-564">
                    <p className="text-[12px] text-[#C5D82D] font-medium mb-1" data-id="element-565">
                      {currentTalk.time} - {currentTalk.endTime}
                    </p>
                    <h3 className="text-[15px] text-white font-medium leading-snug mb-1" data-id="element-566">
                      {currentTalk.title}
                    </h3>
                    {currentTalk.speaker && <p className="text-[13px] text-[#888888]" data-id="element-567">
                        {currentTalk.speaker}
                      </p>}
                  </div>
                </div>
              </div>
            </div>}

          {/* NEXT Section - Only show on Day 1 */}
          {selectedDay === 1 && nextTalk && <div className="mb-6" data-id="element-568">
              <div className="flex items-center gap-2 mb-3" data-id="element-569">
                <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#2A2A2A]" data-id="element-570">
                  <span className="text-[11px] font-medium text-[#888888] uppercase tracking-wider" data-id="element-571">
                    Prossimo
                  </span>
                </div>
              </div>
              <div className="bg-[#141414] rounded-xl border border-[#2A2A2A] p-4" data-id="element-572">
                <div className="flex gap-4" data-id="element-573">
                  {nextTalk.image && <img src={nextTalk.image} alt={nextTalk.speaker} className="w-12 h-12 rounded-full object-cover flex-shrink-0" data-id="element-574" />}
                  <div className="flex-1 min-w-0" data-id="element-575">
                    <p className="text-[12px] text-[#999999] mb-1" data-id="element-576">
                      {nextTalk.time} - {nextTalk.endTime}
                    </p>
                    <h3 className="text-[14px] text-white font-medium leading-snug mb-1" data-id="element-577">
                      {nextTalk.title}
                    </h3>
                    {nextTalk.speaker && <p className="text-[12px] text-[#888888]" data-id="element-578">
                        {nextTalk.speaker}
                      </p>}
                  </div>
                </div>
              </div>
            </div>}

          {/* Program Section */}
          <div className="mb-4" data-id="element-579">
            <h2 className="text-[12px] text-[#888888] uppercase tracking-[0.2em] mb-4" data-id="element-580">
              Programma
            </h2>
            <div className="space-y-1" data-id="element-581">
              {program.map(item => {
              const isActive = selectedDay === 1 && item.id === CURRENT_TALK_ID;
              const isPast = selectedDay === 1 && DAY1_PROGRAM.indexOf(item) < DAY1_PROGRAM.findIndex(i => i.id === CURRENT_TALK_ID);
              return <div key={item.id} className={`flex gap-3 py-3 px-3 rounded-lg transition-all ${isActive ? 'bg-[#141414]' : ''}`} data-id="element-582">
                    {/* Time */}
                    <div className={`w-12 flex-shrink-0 text-[12px] font-medium ${isActive ? 'text-[#C5D82D]' : isPast ? 'text-[#999999]' : 'text-[#888888]'}`} data-id="element-583">
                      {item.time}
                    </div>

                    {/* Speaker Image or Placeholder */}
                    <div className="w-10 h-10 flex-shrink-0" data-id="element-584">
                      {item.image ? <img src={item.image} alt={item.speaker} className={`w-10 h-10 rounded-full object-cover ${isPast ? 'opacity-50' : ''}`} data-id="element-585" /> : item.isBreak ? <div className={`w-10 h-10 rounded-full bg-[#1A1A1A] flex items-center justify-center ${isPast ? 'opacity-50' : ''}`} data-id="element-586">
                          {item.title.toLowerCase().includes('lunch') ? <UtensilsCrossed className="w-4 h-4 text-[#888888]" data-id="element-587" /> : item.title.toLowerCase().includes('coffee') ? <Coffee className="w-4 h-4 text-[#888888]" data-id="element-588" /> : item.title.toLowerCase().includes('closing') ? <Flag className="w-4 h-4 text-[#888888]" data-id="element-589" /> : item.title.toLowerCase().includes('registrazione') ? <ClipboardCheck className="w-4 h-4 text-[#888888]" data-id="element-590" /> : <Coffee className="w-4 h-4 text-[#888888]" data-id="element-591" />}
                        </div> : <div className={`w-10 h-10 rounded-full bg-[#2A2A2A] flex items-center justify-center ${isPast ? 'opacity-50' : ''}`} data-id="element-592">
                          <MessageCircle className="w-4 h-4 text-[#888888]" data-id="element-593" />
                        </div>}
                    </div>

                    {/* Content */}
                    <div className="flex-1 min-w-0" data-id="element-594">
                      <h4 className={`text-[14px] font-medium leading-snug ${isActive ? 'text-white' : isPast ? 'text-[#999999]' : 'text-white'}`} data-id="element-595">
                        {item.title}
                      </h4>
                      {item.speaker && !item.isBreak && <p className={`text-[11px] mt-0.5 ${isPast ? 'text-[#444444]' : 'text-[#888888]'}`} data-id="element-596">
                          {item.speaker}
                        </p>}
                    </div>

                    {/* Active indicator */}
                    {isActive && <div className="flex items-center" data-id="element-597">
                        <div className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse" data-id="element-598" />
                      </div>}
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </div>;
}